import { Scatter} from 'react-chartjs-2';
import React,{Component} from "react";
import PropTypes from 'prop-types';

export class Line extends Component {

shouldComponentUpdate(nextProps){
  if( this.props.Ref.current.chartInstance.data.datasets ===nextProps.Ref.current.chartInstance.data.datasets){
    return false
  }else
 return true
}
  render() {
    return <Scatter
    data = {this.props.data}
    ref= {this.props.Ref}
    options={{
      ...this.props.options,
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        xAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: 'Time (seconds)'
            }
          }
        ],
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: 'Brake'
            }
          }
        ]
      }
    }}
     />;
  }
}

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

Line.propTypes={
Ref:PropTypes.string,
data:PropTypes.string,
options:PropTypes.string
}
Line.defaultProps= {
Ref:[],
data:[],
options:[],
}
